// Enumerations shared by the DB (text + CHECK), the API contracts, the LLM schemas and the UI.
// The zod enums built from these arrays are the source of truth (docs/db.md §0).
export const PARTS_OF_SPEECH = [
    'noun',
    'verb',
    'adjective',
    'adverb',
    'pronoun',
    'adposition',
    'conjunction',
    'interjection',
    'numeral',
    'particle',
    'phrase',
    'idiom',
    'other',
];
// Form labels are codes, localized in the UI: the lexeme is shared by learners of any native language.
export const FORM_LABELS = [
    'plural',
    'singular',
    'past',
    'present',
    'future',
    'infinitive',
    'imperative',
    'comparative',
    'superlative',
    'feminine',
    'masculine',
    'other',
];
export const RELATED_KINDS = ['synonym', 'antonym', 'form', 'collocation'];
export const MEDIA_SOURCES = ['forvo', 'tts'];
export const SHARE_STATUSES = ['pending', 'accepted', 'revoked'];
export const DICTIONARY_ROLES = ['owner', 'teacher'];
// UI locales available at start; the rest are added as catalogs (docs/project.md §5).
export const UI_LOCALES = ['ru', 'en', 'tr'];
export const DEFAULT_UI_LOCALE = 'en';
// Login codes: 6 digits, 10 minutes, 5 attempts (docs/project.md §4).
export const LOGIN_CODE_LENGTH = 6;
export const LOGIN_CODE_TTL_SECONDS = 10 * 60;
export const LOGIN_CODE_MAX_ATTEMPTS = 5;
export const SESSION_TTL_DAYS = 180;
export const SHARE_TOKEN_TTL_DAYS = 14;
export const SYNC_PAGE_SIZE = 500;
// Reopening the same card within this window is not logged (docs/db.md §5).
export const VIEW_DEDUP_MS = 5 * 60 * 1000;
// Block list of disposable e-mail domains — a constant in code (docs/project.md §4).
export const DISPOSABLE_EMAIL_DOMAINS = new Set([
    '10minutemail.com',
    '10minutemail.net',
    '20minutemail.com',
    '33mail.com',
    'anonbox.net',
    'burnermail.io',
    'byom.de',
    'dispostable.com',
    'discard.email',
    'dropmail.me',
    'emailondeck.com',
    'fakeinbox.com',
    'fakemail.net',
    'getairmail.com',
    'getnada.com',
    'guerrillamail.com',
    'guerrillamail.net',
    'guerrillamail.org',
    'guerrillamailblock.com',
    'harakirimail.com',
    'inboxbear.com',
    'incognitomail.com',
    'jetable.org',
    'mail-temp.com',
    'mailcatch.com',
    'maildrop.cc',
    'mailinator.com',
    'mailnesia.com',
    'mailsac.com',
    'mintemail.com',
    'mohmal.com',
    'mytemp.email',
    'nowmymail.com',
    'sharklasers.com',
    'spamgourmet.com',
    'temp-mail.org',
    'temp-mail.io',
    'tempail.com',
    'tempmail.com',
    'tempmail.net',
    'tempmailo.com',
    'tempr.email',
    'throwawaymail.com',
    'trashmail.com',
    'trashmail.me',
    'yopmail.com',
    'yopmail.fr',
]);
export function isDisposableEmail(email) {
    const at = email.lastIndexOf('@');
    if (at < 0)
        return false;
    return DISPOSABLE_EMAIL_DOMAINS.has(email.slice(at + 1).toLowerCase());
}
//# sourceMappingURL=constants.js.map